function retrieveToken() {

    if (localStorage.getItem('items') && localStorage.getItem('items') !== 'undefined') {
    
        const items = JSON.parse(localStorage.getItem('items'));
        const tokenApi = (items !== null) ? items.api_token : false;

        return tokenApi;

    } else {
        return false;
    }

}

export { retrieveToken }